import apiClient from './client';
import { endpoints } from './endpoints';
import type { TutorialProgress } from '@/types';

export const tutorialProgressService = {
  async saveProgress(
    tutorialId: string,
    progressData: Partial<TutorialProgress>
  ): Promise<unknown | null> {
    try {
      const response = await apiClient.post(
        endpoints.tutorials.progress(tutorialId),
        progressData
      );
      return response.data;
    } catch {
      console.warn('Erro ao salvar progresso na API');
      return null;
    }
  },
  async getProgress(tutorialId: string): Promise<unknown | null> {
    try {
      const response = await apiClient.get(endpoints.tutorials.progress(tutorialId));
      return response.data;
    } catch {
      console.warn('Erro ao carregar progresso da API');
      return null;
    }
  },
  saveProgressLocal(tutorialId: string, progressData: Record<string, unknown>): boolean {
    try {
      const key = `tutorial_progress_${tutorialId}`;
      localStorage.setItem(
        key,
        JSON.stringify({ ...progressData, tutorialId, savedAt: new Date().toISOString() })
      );
      return true;
    } catch {
      return false;
    }
  },
  getProgressLocal(tutorialId: string): unknown | null {
    try {
      const data = localStorage.getItem(`tutorial_progress_${tutorialId}`);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  },
  async syncProgress(tutorialId: string): Promise<boolean> {
    const localProgress = tutorialProgressService.getProgressLocal(tutorialId);
    if (localProgress && typeof localProgress === 'object') {
      try {
        await tutorialProgressService.saveProgress(tutorialId, localProgress as Partial<TutorialProgress>);
        localStorage.removeItem(`tutorial_progress_${tutorialId}`);
        return true;
      } catch {
        return false;
      }
    }
    return false;
  },
};

export default tutorialProgressService;
